import { createProviderToken } from '@core/common-legacy';

export interface UnbiasedHiringTranslations {
  beta: {
    description: string;
    close: string;
  };
  infobox: {
    heading: string;
    headingShort: string;
    message: string;
    messageShort: string;
    messageAdmin: string;
    messageWithNoAccessToJob: string;
    headingAdmin: string;
    reviewEvaluations: string;
  };
  evaluate: string;
  evaluateWithForm: string;
  evaluateWithFormTooltip: string;
  addQuickEvaluationTooltip: string;
}

export const {
  provide: provideUnbiasedHiringTranslations,
  inject: injectUnbiasedHiringTranslations,
} = createProviderToken<UnbiasedHiringTranslations>('UnbiasedHiringModuleTranslations')();

export const webappUnbiasedHiringTranslations = provideUnbiasedHiringTranslations({
  useValue: {
    beta: {
      description: 'app.unbiased_hiring.beta.description',
      close: 'app.unbiased_hiring.beta.close',
    },
    infobox: {
      heading: 'app.unbiased_hiring.infobox.heading',
      message: 'app.unbiased_hiring.infobox.message',
      headingShort: 'app.unbiased_hiring.infobox.heading_short',
      messageShort: 'app.unbiased_hiring.infobox.message_short',
      headingAdmin: 'app.unbiased_hiring.infobox.heading_admin',
      messageAdmin: 'app.unbiased_hiring.infobox.message_admin',
      reviewEvaluations: 'app.unbiased_hiring.infobox.review_evaluations',
      messageWithNoAccessToJob: 'app.unbiased_hiring.infobox.message_with_no_access_to_job',
    },
    evaluate: 'app.unbiased_hiring.evaluate',
    evaluateWithForm: 'app.unbiased_hiring.evaluate_with_form',
    evaluateWithFormTooltip: 'app.unbiased_hiring.evaluate_with_form_tooltip',
    addQuickEvaluationTooltip: 'app.interview.add_quick_evaluation_btn',
  },
});
